import { render, staticRenderFns } from "./WLoader.vue?vue&type=template&id=af2f0c8e&"
import script from "./WLoader.vue?vue&type=script&lang=ts&"
export * from "./WLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports